// ---------------------------------------------------------------------------
// Digital Notice Board — starter/demo content
// ---------------------------------------------------------------------------
// Seeded the first time the studio is opened so a school user immediately sees a
// finished-looking example they can edit instead of a blank page.
// ---------------------------------------------------------------------------
import {ELEMENT_TYPES} from "../constants/NoticeBoardConstants";
import {getSchoolIdentity, uid} from "../utils/noticeBoardUtils";

export function buildSampleBoard() {
    const canvas = {preset: "16:9", width: 1920, height: 1080};
    // Pull the logged-in school's name + address so the starter board is
    // pre-branded instead of showing the demo "Greenfield Public School".
    const {name: schoolName, address: schoolAddress} = getSchoolIdentity();
    return {
        id: uid("board"),
        name: "Morning Assembly Board",
        canvas,
        updatedAt: Date.now(),
        slides: [
            {
                id: uid("slide"),
                name: "Welcome",
                background: "#0B2545",
                duration: 8,
                elements: [
                    {
                        id: uid("el"), type: ELEMENT_TYPES.ICON,
                        x: 880, y: 140, w: 170, h: 170, rotation: 0, opacity: 1,
                        icon: "school", color: "#FFD166",
                    },
                    {
                        id: uid("el"), type: ELEMENT_TYPES.HEADING,
                        x: 260, y: 360, w: 1400, h: 160, rotation: 0, opacity: 1,
                        text: schoolName || "Greenfield Public School", fontSize: 110, fontWeight: 700,
                        fontFamily: "Raleway, sans-serif", color: "#FFFFFF",
                        align: "center", bg: "transparent",
                    },
                    {
                        id: uid("el"), type: ELEMENT_TYPES.TEXT,
                        x: 460, y: 540, w: 1000, h: 90, rotation: 0, opacity: 1,
                        text: schoolAddress || "Knowledge • Discipline • Excellence", fontSize: 52,
                        fontWeight: 400, fontFamily: "Roboto, sans-serif",
                        color: "#A9C0E0", align: "center", bg: "transparent",
                    },
                    {
                        id: uid("el"), type: ELEMENT_TYPES.DATE,
                        x: 80, y: 60, w: 760, h: 90, rotation: 0, opacity: 1,
                        fontSize: 46, fontWeight: 500, fontFamily: "Roboto, sans-serif",
                        color: "#FFFFFF", align: "left",
                    },
                    {
                        id: uid("el"), type: ELEMENT_TYPES.CLOCK,
                        x: 1200, y: 60, w: 640, h: 120, rotation: 0, opacity: 1,
                        fontSize: 90, fontWeight: 700, fontFamily: "'Courier New', monospace",
                        color: "#FFD166", align: "right", seconds: true,
                    },
                    {
                        id: uid("el"), type: ELEMENT_TYPES.MARQUEE,
                        x: 0, y: 960, w: 1920, h: 110, rotation: 0, opacity: 1,
                        text: "Annual Sports Day on Friday • Parent-Teacher meeting this Saturday 10 AM • Library reopens Monday",
                        fontSize: 52, fontWeight: 600, fontFamily: "Roboto, sans-serif",
                        color: "#0B2545", bg: "#FFD166", speed: 14,
                    },
                ],
            },
            {
                id: uid("slide"),
                name: "Today's Notice",
                background: "#F7FAFC",
                duration: 10,
                elements: [
                    {
                        id: uid("el"), type: ELEMENT_TYPES.HEADING,
                        x: 260, y: 70, w: 1400, h: 150, rotation: 0, opacity: 1,
                        text: "Today's Notices", fontSize: 96, fontWeight: 700,
                        fontFamily: "Raleway, sans-serif", color: "#1A202C",
                        align: "center", bg: "transparent",
                    },
                    {
                        id: uid("el"), type: ELEMENT_TYPES.NOTICE,
                        x: 120, y: 280, w: 820, h: 640, rotation: 0, opacity: 1,
                        title: "Annual Sports Day", accent: "#38A169",
                        body: "Grades 6–10 report to the ground by 8:00 AM in house colours. Track events begin at 9:00 AM sharp.",
                        titleSize: 62, bodySize: 42, color: "#1A202C",
                        bg: "#FFFFFF", radius: 18,
                    },
                    {
                        id: uid("el"), type: ELEMENT_TYPES.NOTICE,
                        x: 980, y: 280, w: 820, h: 640, rotation: 0, opacity: 1,
                        title: "Exam Timetable", accent: "#DD6B20",
                        body: "Half-yearly examinations start next Monday. The detailed timetable is on the school portal and class boards.",
                        titleSize: 62, bodySize: 42, color: "#1A202C",
                        bg: "#FFFFFF", radius: 18,
                    },
                ],
            },
        ],
    };
}
